<template>
	<div id="InventoryRun" class="inventory-run">
		<inventory-run-component :inventoryId="inventoryIdLocal" ref="inventoryRunComponent"></inventory-run-component>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import inventories from '@/mixins/inventories'

	import InventoryRunComponent from '@/components/InventoryRunComponent.vue'

	export default {
		name: 'InventoryRun',
		mixins: [axiosAction, errors, mixin, inventories],
		props: ['inventoryId'],
		data() {
			return {
				inventoryIdLocal: this.inventoryId
			}
		},
		components: {
			'inventory-run-component': InventoryRunComponent,
		},
		computed: {
		},
		methods: {
			initModuleLocal() {
				this.setTitleModule('Inventario')
				this.setSubTitleModule('')
				this.setModuleLocal()
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'showInventoryResult': this.showInventoryResult(response); break;				
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			setModuleLocal() {
				if(this.inventoryId == undefined) {
					this.showInventoryCurrent()
				} else {
					this.showInventory(this.inventoryIdLocal)
				}
			},
			showInventoryResultLocal(response) {
				if(response.data.success == true) {
					this.inventoryIdLocal = this.objectInventory.id
					this.setTitleModule('Inventario ' + this.objectInventory.year)
				}
			}
		},
		mounted () {
			this.initModule()
		}
	}

</script>

<style scoped lang="scss">
</style>